import "./impressum.css";
import { useEffect } from "react";

export default function Impressum() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="impressum">
      <br /><br />
      <h1>Impressum</h1>

      <h2>Angaben gemäß § 5 TMG</h2>
      <p>
        Ingenieurbüro Stein &amp; Wagner GbR<br />
        Südallee 31–35<br />
        56068 Koblenz<br />
        Deutschland<br /><br />
        E-Mail: info@suw-ing.de<br />
        Web: www.suw-ing.de
      </p>

      <h2>Gesellschafter</h2>
      <p>
        <strong>Alexander Stein</strong><br />
        Südallee 31–35<br />
        56068 Koblenz<br />
        <a href="mailto:alexander.stein@suw-ing.de">
          alexander.stein@suw-ing.de
        </a>
        <br /><br />

        <strong>Sebastian Wagner</strong><br />
        Wiesental 7<br />
        57639 Rodenbach<br />
        <a href="mailto:sebastian.wagner@suw-ing.de">
          sebastian.wagner@suw-ing.de
        </a>
        <br />
      </p>

      <h2>Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG</h2>
      <p>-</p>

      <h2>Inhaltlich Verantwortlicher gemäß § 18 Abs. 2 MStV</h2>
      <p>Alexander Stein (Anschrift siehe oben)</p>

      <h2>Berufshaftpflichtversicherung</h2>
      <p>
        Versicherer: -<br />
        Räumlicher Geltungsbereich: -
      </p>

      <h2>Quellenangaben für Bilder und Grafiken</h2>
      <p>Eigene Bilder / © Ingenieurbüro Stein &amp; Wagner GbR</p>

      <h2>Haftungsausschluss</h2>

      <p>
        <strong>Haftung für Inhalte</strong><br />
        Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
        Nach §§ 8 bis 10 TMG sind wir jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von Rechtsverletzungen entfernen wir die Inhalte umgehend.
        {/* Rest wie oben */}
      </p>

      <p>
        <strong>Haftung für Links</strong><br />
        Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb übernehmen wir für diese fremden Inhalte keine Gewähr. Für Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.
        Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft; rechtswidrige Inhalte waren zu diesem Zeitpunkt nicht erkennbar.
        Eine permanente inhaltliche Kontrolle ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen entfernen wir derartige Links umgehend.
      </p>

      <h2>Datenschutz</h2>
      <p>
        Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich.
        Soweit auf unseren Seiten personenbezogene Daten erhoben werden (z. B. Name, Anschrift, E‑Mail‑Adresse), erfolgt dies stets auf freiwilliger Basis.
        Diese Daten werden ohne ausdrückliche Zustimmung nicht an Dritte weitergegeben.
        Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. per E‑Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
        Der Nutzung der im Impressum veröffentlichten Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter Werbung wird hiermit widersprochen. Die Betreiber behalten sich rechtliche Schritte im Falle unverlangter Zusendung von Werbung (z. B. Spam-Mails) vor.
      </p>
    </section>
  );
}